export default __webpack_public_path__ + "static/media/ag òl.988a1789.mp3";